import { createUseStyles, Styles } from '../../web-styles'

interface InputStyles {
  inputWrapper: Styles
  input: Styles
  error: Styles
}

interface InputStylesProps {
  isError: boolean
  disabled?: boolean
}

export const useStyles = createUseStyles<InputStyles, InputStylesProps>((theme) => {
  const getBorderColor = (props: InputStylesProps, state?: 'default' | 'hover' | 'focus') => {
    if (props.disabled) {
      return `${theme.colors.inputBorderColor} !important`
    }

    switch (state) {
      case 'hover':
        return theme.colors.inputHoverBorderColor
      case 'focus':
        return theme.colors.inputActiveBorderColor
      default:
        return theme.colors.inputBorderColor
    }
  }

  return {
    inputWrapper: (props) => ({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: theme.calcUnit(1),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      marginBottom: theme.calcUnit(theme.spacing.s1),
      borderColor: getBorderColor(props),
      backgroundColor: props.disabled ? theme.colors.webFadedBackground : '',
      transition: 'border-color 0.3s ease-in-out, background-color 0.3s ease-in-out',
      '&:hover': {
        borderColor: props.disabled ? '' : getBorderColor(props, 'hover'),
      },
      '&:focus-within': {
        borderColor: getBorderColor(props, 'focus'),
      },
    }),
    input: {
      outline: 'none',
      width: '100%',
      marginInline: theme.calcUnit(theme.spacing.s3),
      marginTop: theme.calcUnit(theme.spacing.s2),
      marginBottom: theme.calcUnit(theme.spacing.s2),
      backgroundColor: 'transparent',
      fontFamily: 'Roboto',
      color: theme.colors.webTextColor,
      '&::placeholder': {
        color: theme.colors.webTextField,
      },
    },
    error: (props) => ({
      borderColor: props.isError ? theme.colors.inputErrorBorderColor : '',
      '&:focus-within': {
        borderColor: theme.colors.inputErrorBorderColor,
      },
      '&:hover': {
        borderColor: theme.colors.inputErrorBorderColor,
      },
    }),
  }
})
